/*
 * Aspetto delle tendine react-select allineato al resto del Manager: bordo sottile
 * arrotondato, niente separatore, freccia discreta, voce scelta in grassetto.
 * Uso: <Select styles={sidSelectStyles} ... />
 */
const TESTO = '#1A1A1A';
const BORDO = '#E3E5E9';

export const sidSelectStyles = {
	control: (base, state) => ({
		...base,
		minHeight: 40,
		borderRadius: 10,
		borderColor: state.isFocused ? TESTO : BORDO,
		boxShadow: 'none',
		backgroundColor: state.isDisabled ? '#F5F6F8' : '#fff',
		cursor: state.isDisabled ? 'default' : 'pointer',
		'&:hover': { borderColor: state.isFocused ? TESTO : '#B8BCC4' },
	}),
	valueContainer: (base) => ({ ...base, padding: '0 12px' }),
	singleValue: (base) => ({ ...base, color: TESTO, fontSize: 15 }),
	placeholder: (base) => ({ ...base, color: '#8A8F99', fontSize: 15 }),
	indicatorSeparator: () => ({ display: 'none' }),
	dropdownIndicator: (base, state) => ({
		...base,
		color: '#8A8F99',
		padding: '0 10px',
		transition: 'transform .15s ease',
		transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'none',
		'&:hover': { color: TESTO },
	}),
	menu: (base) => ({
		...base,
		borderRadius: 10,
		border: `1px solid ${BORDO}`,
		boxShadow: '0 8px 24px rgba(16, 24, 40, .08)',
		overflow: 'hidden',
		zIndex: 20,
	}),
	menuList: (base) => ({ ...base, padding: 4 }),
	option: (base, state) => ({
		...base,
		borderRadius: 6,
		fontSize: 15,
		color: TESTO,
		fontWeight: state.isSelected ? 600 : 400,
		backgroundColor: state.isFocused ? '#F1F2F4' : 'transparent',
		cursor: 'pointer',
		'&:active': { backgroundColor: '#E3E5E9' },
	}),
	multiValue: (base) => ({ ...base, borderRadius: 999, backgroundColor: '#F1F2F4' }),
};

export default sidSelectStyles;
